<!-- Item Start Outlet -->
<ng-template [cxOutlet]="CartOutlets.ITEM">
  <div class="row">
    <!-- Item Image -->
    <div
      class="cart-item__left col-12 col-sm-6"
      [class]="{ 'col-lg-5': !compact, 'col-lg-4': compact }"
    >
      <div class="row">
        <div class="eb-image-container">
          <a
            *ngIf="item.product?.approved; else showImageWithoutLink"
            [routerLink]="['/' + item.product.fullProductPath + '/v/' + item.product.code] | cxUrl"
            cxModal="dismiss"
            tabindex="-1"
          >
            <cx-media
              [container]="item.product.images?.PRIMARY || item.product.images"
              [alt]="item.product.name"
              format="cartIcon"
            ></cx-media>
          </a>
        </div>
        <ng-template #showImageWithoutLink>
          <cx-media
            [container]="item.product.images?.PRIMARY"
            [alt]="item.product.name"
            format="cartIcon"
          ></cx-media>
        </ng-template>
        <div class="cx-info-container col-7 col-sm-9">
          <!-- Item Description -->
          <div class="cx-name">
            <a
              *ngIf="item.product?.approved; else showTitleWithoutLink"
              class="cx-link"
              [routerLink]="
                ['/' + item.product.fullProductPath + '/v/' + item.product.code] | cxUrl
              "
              cxModal="dismiss"
              [attr.data-cy]="'variant-link-' + item.product.code"
              ><h2>{{ item.product?.name || item.product.code }}</h2></a
            >
          </div>
          <ng-template #showTitleWithoutLink>
            <h2>{{ item.product?.name || item.product.code }}</h2>
          </ng-template>

          <!-- AVAILABILITY -->
          <ng-container *ngIf="item.product?.orderable && showAvailability">
            <ng-container *ngIf="availabilityLoading; else availabilityTemplate">
              <eb-spinner class="product-detail__availability-spinner" size="1"></eb-spinner>
            </ng-container>
            <ng-template #availabilityTemplate>
              <eb-product-availability
                *ngIf="availabilityItem"
                [availability]="availabilityItem"
                [error]="availabilityError"
                [attr.data-cy]="'availability_' + item.product.code"
              ></eb-product-availability>
            </ng-template>
          </ng-container>

          <div *ngIf="item.product?.code" class="cx-code" data-cy="material-code">
            {{ 'cartItems.id' | cxTranslate }} {{ item.product.code }}
          </div>
          <div *ngIf="item.product?.customerMaterialNumber" class="cx-code" data-cy="material-code">
            {{ 'cartItems.customerMaterialNumber' | cxTranslate }}
            {{ item.product.customerMaterialNumber }}
          </div>
        </div>
      </div>
    </div>
    <!-- Item Information -->
    <div
      class="cart-item__right col-12 col-sm-6"
      [class]="{ 'col-lg-7': !compact, 'col-lg-8': compact }"
    >
      <div class="row" [class.price-less]="!showPrice || !(priceItem$ | async)">
        <!-- Item Price -->
        <div
          class="cx-price"
          *ngIf="showPrice"
          [ngClass]="{
            'col-lg-5': hideQuantity,
            'col-lg-3': !hideQuantity
          }"
        >
          <ng-container *ngIf="(priceItem$ | async) && showPrice">
            <div class="cx-label d-block d-lg-none d-xl-none">
              {{ 'cartItems.itemPrice' | cxTranslate }}
            </div>
            <div class="cx-value" data-cy="item-price">
              {{
                (priceItem$ | async)?.value > 0
                  ? (priceItem$ | async)?.formattedValue
                  : ('cartItems.priceOnRequest' | cxTranslate)
              }}
            </div>
          </ng-container>
        </div>
        <!-- Item Unit -->
        <div
          class="cx-unit"
          [ngClass]="{
            'col-lg-7': hideQuantity,
            'col-lg-2': !hideQuantity
          }"
        >
          <div class="cx-label d-block d-lg-none d-xl-none">
            {{ 'cartItems.unit' | cxTranslate }}
          </div>
          <!--          {{ item.unit | json }}-->
          <div class="cx-value">
            {{ item?.unit }}
          </div>
        </div>
        <!-- Item Quantity -->
        <div
          *ngIf="!hideQuantity"
          [class]="showAddToCart ? 'cx-quantity col-lg-5' : 'cx-quantity col-lg-4'"
        >
          <div class="cx-label">
            {{ 'cartItems.quantity' | cxTranslate }}
          </div>
          <div class="cx-value">
            <ng-container *ngIf="quantityControl; else quantity">
              <eb-item-counter
                #counterRef
                [control]="quantityControl"
                [readonly]="!item.updateable || readonly || options.isSaveForLater"
                [max]="item.product.stock?.stockLevel || 1000"
                [allowZero]="true"
                (keyup.enter)="onEnter(counterRef)"
                [attr.data-cy]="'eb-cart-item__counter'"
                [productPrice]="item.basePrice.value"
                [cartPopUp]="cartPopUp"
                [pushMatomoEvents]="true"
              >
              </eb-item-counter>
              <eb-product-sales-text
                [cssClass]="'eb-cart-item'"
                [salesText]="item?.product?.productSalesView?.salesText"
              ></eb-product-sales-text>
            </ng-container>
            <ng-template #quantity>
              {{ item?.quantity }}
            </ng-template>
          </div>
        </div>
        <!-- Total -->
        <ng-container *ngIf="options.isSaveForLater; else total">
          <div class="cx-total col-lg-3">
            <div *ngIf="item?.product?.stock?.stockLevel >= 0; else forceInstock" class="cx-value">
              {{ item.product.stock.stockLevel }}
            </div>
            <ng-template #forceInstock>
              <div class="cx-value">
                {{ 'saveForLaterItems.forceInStock' | cxTranslate }}
              </div>
            </ng-template>
          </div>
        </ng-container>

        <!-- Item Bundle Details Outlet -->
        <ng-template [cxOutlet]="CartOutlets.ITEM_BUNDLE_DETAILS"></ng-template>

        <!-- Promotion -->

        <!-- Actions -->
        <ng-container *ngIf="showAddToCart">
          <ng-container *ngIf="priceLoading; else showPriceSection">
            <eb-spinner class="eb-cart-item__price-spinner" size="2"></eb-spinner>
          </ng-container>
          <ng-template #showPriceSection>
            <ng-container
              *ngIf="priceItem?.value > 0 || hasSuccessor(item?.product); else showRequestQuote"
            >
              <div class="eb-cart-item__add-to-cart">
                <eb-purchase-product
                  [product]="
                    hasSuccessor(item?.product) && !item?.product.orderable
                      ? item?.product.successor
                      : item?.product
                  "
                  [isAvailable]="
                    hasSuccessor(item?.product)
                      ? item?.product.successor?.orderable
                      : item?.product.orderable
                  "
                  [showSuccessor]="hasSuccessor(item?.product) && !item?.product.orderable"
                  [showQuantity]="false"
                ></eb-purchase-product>
              </div>
            </ng-container>
            <ng-template #showRequestQuote>
              <div class="eb-cart-item__add-to-cart">
                <a
                  class="eb-cart-item__request-quote-btn"
                  [attr.data-cy]="'request-link-' + item?.product.code"
                  [routerLink]="['/rfp']"
                  [queryParams]="{
                    productCode: item?.product.code,
                    productName: item?.product.name
                  }"
                >
                  {{ 'requestQuote.sendRequest' | cxTranslate }} <em class="fas fa-file-alt"></em>
                </a>
              </div>
            </ng-template>
          </ng-template>
        </ng-container>
      </div>
      <div
        *ngIf="(!readonly || options.isSaveForLater) && item.updateable"
        class="cx-actions col-12"
      >
        <ng-container *ngIf="!isProductOutOfStock(item?.product)">
          <ng-container
            *ngTemplateOutlet="
              options.optionalBtn;
              context: {
                $implicit: { loading: quantityControl?.disabled, item: item }
              }
            "
          ></ng-container>
        </ng-container>

        <ng-container *ngIf="quantityControl">
          <button
            class="cx-remove-btn link"
            [disabled]="quantityControl?.disabled"
            (click)="removeItem()"
          >
            {{ 'common.remove' | cxTranslate }}
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <ng-container *ngIf="item?.product as product">
    <div *ngIf="!product.orderable" class="row eb-cart-item__orderable">
      <eb-info-box
        *ngIf="product.successor; else rfpLink"
        icon="info-circle"
        infoType="INFO"
        class="col-lg-8"
      >
        <span>{{ 'cartItems.hasSuccessorProductText' | cxTranslate }} </span>
        <a
          class="eb-replacement-link"
          [routerLink]="getSuccessorLink(product.successor.code)"
          [attr.data-cy]="'successor-link-' + product.successor.code"
          >{{ product.successor.code }} - {{ product.successor.name }}
        </a>
      </eb-info-box>
      <ng-template #rfpLink>
        <eb-info-box icon="exclamation-triangle" infoType="DANGER-LIGHT" class="col-lg-8">
          <span>{{ 'cartItems.nonPurchasableText' | cxTranslate }} </span>
          <a
            class="eb-replacement-link"
            [routerLink]="['/rfp']"
            [queryParams]="{ productCode: product.code, productName: product.name }"
            >{{ 'cartItems.nonPurchasableRfpLink' | cxTranslate }}
          </a>
        </eb-info-box>
      </ng-template>
    </div>
  </ng-container>

  <ng-template #total>
    <div *ngIf="!hideQuantity && item.totalPrice" class="cx-total col-lg-3">
      <div class="cx-label d-block d-lg-none d-xl-none">
        {{ 'cartItems.total' | cxTranslate }}
      </div>
      <div class="cx-value">
        {{
          item?.totalPrice?.value > 0
            ? item?.totalPrice?.formattedValue
            : ('cartItems.priceOnRequest' | cxTranslate)
        }}
      </div>
    </div>
  </ng-template>
</ng-template>
